import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../../services/user/user.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {Router} from '@angular/router';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {RedirectService} from '../../../services/redirect/redirect.service';
import {EvaluationService} from '../../../services/evaluation/evaluation.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-evaluation-result',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    TranslateModule
  ],
  templateUrl: './evaluation-result.component.html',
  styleUrls: ['./evaluation-result.component.scss']
})
export class EvaluationResultComponent implements OnInit {

  @Input() codeLang: string;
  @Input() response: any;

  loader = true;
  affectLoader = false;
  level: any;

  constructor(
    private evaluationSrv: EvaluationService,
    private userSrv: UserService,
    private levelSrv: GameLevelService,
    private langSrcSrv: LangSrcService,
    private langTgtSrv: LangTgtService,
    private router: Router,
    private redirectSrv: RedirectService,
    private modal: NgbActiveModal
  ) {
  }

  async ngOnInit() {
    const completed: any = await this.evaluationSrv.completed(this.codeLang);
    if (!completed) {
      await this.router.navigate([
        '/',
        this.langSrcSrv.current.shortCode,
        'evaluation',
        this.codeLang
      ]);
      this.modal.close(true);
      return;
    }
    if (this.response.redirectTo === 'level') {
      this.level = await this.levelSrv.findById(this.response.uniqid, this.codeLang);
    }
    this.loader = false;
  }

  async goToCurrentLevel() {
    const currentLevel: any = await this.userSrv.currentLevel(this.codeLang);
    const langTgt = this.langTgtSrv.langs.find(x => x.code === this.codeLang);
    await this.redirectSrv.toLevel(langTgt, currentLevel.section, currentLevel.level);
  }

  async affectLevelAndRedirect() {
    this.affectLoader = true;
    await this.evaluationSrv.affect(this.codeLang);
    await this.goToCurrentLevel();
  }

  async goToDashboard() {
    const langTgt = this.langTgtSrv.langs.find(x => x.code === this.codeLang);
    await this.redirectSrv.toPlatform(langTgt, true);
  }

}
